/**
 * SiteStateRequiredBanner — R-7 wizard surface when conflict detection
 * cannot run because the site state prior is missing.
 */
import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '../ui/button';

export interface SiteStateRequiredBannerProps {
  message?: string;
  onOpenSiteIntent?: () => void;
  onDismiss?: () => void;
  testId?: string;
}

export function SiteStateRequiredBanner({
  message = 'Report generation needs a US state for this site. Add a state to the site address or set location state in Project Intent, then retry.',
  onOpenSiteIntent,
  onDismiss,
  testId = 'site-state-required-banner',
}: SiteStateRequiredBannerProps) {
  return (
    <div
      data-testid={testId}
      className="rounded-md border border-amber-500/40 bg-amber-500/10 px-4 py-3 text-[12px] text-text-primary"
      role="alert"
    >
      <div className="flex items-start gap-2">
        <AlertTriangle className="h-4 w-4 shrink-0 text-amber-600 mt-0.5" aria-hidden />
        <div className="flex-1 space-y-2">
          <p className="font-semibold">Site state required</p>
          <p className="text-text-secondary leading-relaxed">{message}</p>
          <div className="flex flex-wrap gap-2">
            {onOpenSiteIntent && (
              <Button type="button" size="sm" variant="secondary" onClick={onOpenSiteIntent}>
                Open Project Intent
              </Button>
            )}
            {onDismiss && (
              <Button type="button" size="sm" variant="ghost" onClick={onDismiss}>
                Dismiss
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
